import React, { useState, useEffect } from "react";
import "./Navbar.css";
import logoNuevo from "../../Assets/logo_nuevo.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const changeWidth = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", changeWidth);
    return () => window.removeEventListener("resize", changeWidth);
  }, []);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (menuOpen && !e.target.closest(".navbar")) setMenuOpen(false);
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [menuOpen]);

  return (
    <nav className="navbar">
      <a href="/" className="nav-brand" onClick={closeMenu}>
        <img src={logoNuevo} alt="Bianca Angelucci" className="nav-logo" width="2305" height="300" />
      </a>

      <button
        onClick={() => setMenuOpen(!menuOpen)}
        className="nav-hamburger"
        aria-label="Menu"
        aria-expanded={menuOpen}
      >
        {menuOpen ? '✕' : '☰'}
      </button>

      {(menuOpen || screenWidth > 768) && (
        <div className="nav-menu">
          <div className="nav-links">
            <a href="/" className="nav-link" onClick={closeMenu}>Inicio</a>
            <a href="/#about" className="nav-link" onClick={closeMenu}>Sobre mi</a>
            <a href="/#services" className="nav-link" onClick={closeMenu}>Servicios</a>
            <a href="/#consultorio" className="nav-link" onClick={closeMenu}>Consultorio</a>
            <a href="/#faqs" className="nav-link" onClick={closeMenu}>Preguntas frecuentes</a>
            <a href="/#contact" className="nav-link" onClick={closeMenu}>Contacto</a>
          </div>
          <div className="nav-ctas">
            <a href="/calendar" className="nav-cta-turno" onClick={closeMenu}>
              Sacar turno
            </a>
            <a
              href="https://tienda.bianangelucci.com.ar/"
              className="nav-cta-tienda"
              target="_blank"
              rel="noreferrer"
              onClick={closeMenu}
            >
              Tienda online
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
